module.exports = __webpack_public_path__ + "6NWsYel66POcs10XV/RDC_RED_Logo_House.svg";